import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialValues } from "../../components/formData/initialValues";
import { DaikinFormData } from "../../components/formData/DaikinFormData";
import ShellState from "./state";

const steps = [{
  id: 1,
  name: "Site Detail",
}, {
  id: 2,
  name: "Pricing Option",
}, {
  id: 3,
  name: "Summary",
}, {
  id: 4,
  name: "Thank you",
}]

export default createSlice({
  name: "shell",
  initialState: {
    layout: 0,
    step: {
      currentStep: 1,
      doneStep: 0,
      steps: steps,
    },
    isAuth: false,
    setting: {
      autoScroll: true,
      grabToScroll: false,
      alertScroll: true,
      scrollTarget: ""
    },
    productData: {
      isLoaded: false,
      stcVeecs: {
        'GAUS-300FQS': {
          stcs_number: 34,
          stcs_cost: 0,
          veec_number: 31,
          veec_cost: 0,
        },
        'GAUS-250FQS': {
          stcs_number: 34,
          stcs_cost: 0,
          veec_number: 31,
          veec_cost: 0,
        },
        'GAUS-315FQS': {
          stcs_number: 34,
          stcs_cost: 0,
          veec_number: 31,
          veec_cost: 0,
        },
        'GAUS-160FQS': {
          stcs_number: 34,
          stcs_cost: 0,
          veec_number: 31,
          veec_cost: 0,
        },
        'GAUS-315FQV': {
          stcs_number: 34,
          stcs_cost: 0,
          veec_number: 31,
          veec_cost: 0,
        }
      }
    },
    templates: {
      sms: '',
      signature: [],
      notes: [],
    },
    initialValues: initialValues,
    leadData: {
      isLoading: false,
      useDataLead: false,
    },
    productChoice: {}
  } as ShellState,
  reducers: {
    updateAutoScroll: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        setting: {
          ...state.setting,
          autoScroll: action.payload
        }
      }
    },
    updateGrabToScroll: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        setting: {
          ...state.setting,
          grabToScroll: action.payload
        }
      }
    },
    updateAlertScroll: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        setting: {
          ...state.setting,
          alertScroll: action.payload
        }
      }
    },
    updateCurrentStep: (state, action: PayloadAction<number>) => {
      // Limit payload in range 1..4
      let payload = action.payload;
      if (payload < 1) {
        payload = 1;
      } else if (payload > 4) {
        payload = 4;
      }

      return {
        ...state,
        step: {
          ...state.step,
          currentStep: payload
        },
      }
    },
    updateDoneStep: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        step: {
          ...state.step,
          doneStep: action.payload
        },
      }
    },
    updateIsAuth: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isAuth: action.payload
      }
    },
    updateLayout: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        layout: action.payload
      }
    },
    updateQuoteId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        quoteId: action.payload
      }
    },
    updateLeadId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        leadId: action.payload
      }
    },
    updateWaterQuality: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        waterQuality: action.payload
      }
    },
    updateProductData: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          daikins: action.payload,
        }
      }
    },
    updatePEAdmin: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          peAdmin: action.payload,
        }
      }
    },
    updateStcVeecs: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          stcVeecs: action.payload
        }
      }
    },
    updateLeadState: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        leadData: {
          ...action.payload
        }
      }
    },
    updateSMSTemplate: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        templates: {
          ...state.templates,
          sms: action.payload
        }
      }
    },
    updateSMSSignatureTemplate: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        templates: {
          ...state.templates,
          signature: action.payload
        }
      }
    },
    updateNoteTemplate: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        templates: {
          ...state.templates,
          notes: action.payload
        }
      }
    },
    updateLastPostCode: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          lastPostCode: action.payload
        }
      }
    },
    updateScrollTarget: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        setting: {
          ...state.setting,
          scrollTarget: action.payload
        }
      }
    },
    updateQuoteData: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        quote: {
          id: action.payload.id,
          number: action.payload.number,
        }
      }
    },
    updateInitialValues: (state, action: PayloadAction<DaikinFormData>) => {
      return {
        ...state,
        initialValues: action.payload,
      }
    },
    updateLeadDataIsLoading: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        leadData: {
          ...state.leadData,
          isLoading: action.payload
        }
      }
    },
    updateUseDataLead: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        leadData: {
          ...state.leadData,
          useDataLead: action.payload
        }
      }
    },
    updateIsLoaded: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          isLoaded: action.payload
        }
      }
    },
    updatePricingOptions: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        productData: {
          ...state.productData,
          pricingOptions: action.payload
        }
      }
    },
    updateSummaryChoice: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        summaryChoice: action.payload
      }
    },
    updateLeadSource: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        leadSource: action.payload
      }
    },
    updateSelectedFile: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        selectedFiles: action.payload
      }
    },
    updateTmp: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        tmp: action.payload
      }
    },
    updateProductChoice: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        productChoice: action.payload
      }
    },
    updateErrorNotifs: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        errorNotifs: action.payload
      }
    }
  },
});